export var FEDRAMP_MODERATE = 'fedramp-moderate';
export var COMMERCIAL = 'commercial';
export var STAGING = 'staging';
export var PRODUCTION = 'prod';
export var DEV = 'dev';
export var ISOLATED_CLOUD_PERIMETERS = [COMMERCIAL];
export var NON_ISOLATED_CLOUD_PERIMETERS = [COMMERCIAL, FEDRAMP_MODERATE];
export var ATL_CTX_PERIMETER = 'Atl-Ctx-Perimeter';
export var ATL_CTX_ISOLATION_CONTEXT_DOMAIN = 'Atl-Ctx-Isolation-Context-Domain';
export var ATL_CTX_ISOLATION_CONTEXT_ID = 'Atl-Ctx-Isolation-Context-Id';